import { forwardRef, SyntheticEvent, useEffect } from 'react'
import { useModal } from '../../hooks'

export interface Props {
  className?: string
  children?: React.ReactNode
  onOpen?: () => void
  onClose?: () => void
  ariaModal?: boolean
}

function ModalImplementation(
  { children, className, onOpen, onClose, ariaModal = true }: Props,
  ref: React.Ref<HTMLDialogElement>,
) {
  const { isOpen, close, setReturnValue } = useModal()

  const closeOnEscape = (e: KeyboardEvent) => {
    if (e.key === 'Escape') close()
  }

  useEffect(() => {
    window.addEventListener('keydown', closeOnEscape)

    return () => {
      window.removeEventListener('keydown', closeOnEscape)
    }
  })

  useEffect(() => {
    if (isOpen) {
      onOpen && onOpen()
    } else {
      onClose && onClose()
    }
  }, [isOpen])

  const onCloseFn = (e: SyntheticEvent<HTMLDialogElement>) => {
    e.preventDefault()
    setReturnValue(e.currentTarget.returnValue)
    close()
  }

  return (
    <dialog
      open={isOpen}
      onClose={onCloseFn}
      ref={ref}
      className={className}
      aria-modal={ariaModal}
    >
      {isOpen && children}
    </dialog>
  )
}

export const Modal = forwardRef(ModalImplementation)
